import { FlipCardComponent } from '../../../models/LessonComponent';
import { FlipCardEdit } from './FlipCardEdit';
import { FlipCardView } from './FlipCardView';
import React from 'react';
import { useLessonContext } from '../../../models/LessonContext';

export interface FlipCardProps {
  component: FlipCardComponent;
  onSubmit: (value: string) => void;
}
export const FlipCard = (props: FlipCardProps) => {
  const { mode } = useLessonContext();

  return mode === 'edit' ? (
    <FlipCardEdit {...props} />
  ) : (
    <FlipCardView {...props} />
  );
};
